import { useTranslation } from "react-i18next"
import { Modal } from "../../common"
import { Button } from "../../App.styles"

const LockByChallengeModal = ({ onDismiss, show }) => {
    const { t } = useTranslation()

    return (
        <Modal onDismiss={onDismiss} show={show}>
            <div className="modal-header">
                <h4 className="modal-title">{t('Lock to Challenges')}</h4>
                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-hidden="true"
                    onClick={onDismiss}
                >
                    ×
                </button>
            </div>
            <div className="modal-body">
                <p>
                    {t(`You can choose to lock this reward to a set of challenges, and even particular 
                    answers in some cases. In order to get this reward, all specified challenges/answers 
                    must be provided or completed.`)}
                </p>
            </div>
            <div className="modal-footer">
                <Button type="button" color="dark" data-dismiss="modal" onClick={onDismiss}>
                    {t('Close')}
                </Button>
            </div>
        </Modal>
    )
}

export default LockByChallengeModal
